import { render, staticRenderFns } from "./Assessments.vue?vue&type=template&id=83730678"
import script from "./Assessments.vue?vue&type=script&lang=js"
export * from "./Assessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports